export const SET_ABOUT = 'SET_ABOUT';
export const CLEAR_ABOUT = 'CLEAR_ABOUT';

export const clearAbout = {
  type: CLEAR_ABOUT,
}

export const setAbout = (data) => {
  return {
    type: SET_ABOUT,
    payload: data,
  }
}